<template>
    <div>
        <va-row v-if="$route.params.id">
            <va-column :lg="12" :md="12" :sm="12" :xs="12">
                <va-card :elevation="2" :padding="10" style="padding: 10px">
                    <div slot="topLeft">{{ _("Add a comment") }}</div>
                    <div slot="topRight">
                        <span style="color: gray; margin-right: 10px; font-size: 13px">( alt + enter )</span>
                        <va-button @click.native="addComment" type="primary" style="max-height: 22px; font-size: 12px;">
                            {{ _('Comment') }}</va-button>

                    </div>
                    <va-textarea v-model="commentText" @keyup.native.alt.enter="addComment" style="width: 100%"
                        :resize="false"></va-textarea>
                </va-card>
            </va-column>
        </va-row>
        <va-row>
            <va-column :lg="12" :md="12" :sm="12" :xs="12">
                <div :class="{activity_wrapper_click: true, activity_wrapper_no_click: $route.params.id}"
                    @click="navigate(activity)">

                    <div style=" align-self: flex-start; padding-left: 30px; z-index: 10;">
                        <div style="width: 36px; border-radius: 100px; margin-right: 10px"></div>
                    </div>
                    <div class="dot_line"></div>

                    <div style="margin-bottom: 40px; margin-top:4px;">
                    </div>
                </div>
                <div v-for="(activity, index) in activities"
                    :class="{activity_wrapper_click: true, activity_wrapper_no_click: $route.params.id}"
                    @click="navigate(activity)" v-if="activity.get('createdBy')!=null">

                    <div style=" align-self: flex-start; padding-left: 30px; z-index: 10;">
                        <img v-if="activity.get('createdBy').get('profilePic')"
                            :src="activity.get('createdBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')"
                            alt="profile"
                            style="width: 36px;     height: 36px;border-radius: 100px; margin-right: 10px">
                        <img v-else src="@/assets/emptyProfile.jpg" alt="profile"
                            style="width: 36px; border-radius: 100px; margin-right: 10px">
                    </div>
                    <div v-if="index<(activities.length-1) || activities.length  !== allActivitiesCount"
                        class="dot_line">
                    </div>

                    <div v-if="activity.get('comment')" style="width: 100%; margin-bottom: 30px; margin-top:0px;">
                        <va-card :elevation="2" :padding="10" style="padding: 10px">
                            <div slot="topLeft">
                                <va-icon color="gray" type="comments"></va-icon>
                                <span
                                    style="margin-left: 10px">{{ activity.get('createdBy').id == user.id ? 'You' : activity.get('createdBy').get('name') }}</span>
                                <span class="status"
                                    v-if="getSystemLanguage == 'english'">{{ getTime(activity.createdAt) }}</span>
                            </div>
                            <p>{{ activity.get('comment') }}</p>
                        </va-card>
                    </div>

                    <div v-else style="margin-bottom: 50px; margin-top:4px;">
                        <span
                            style="font-weight: bold">{{ activity.get('createdBy').id == user.id ? _('You') : activity.get('createdBy').get('name') }}</span>
                        <span style="margin-left: 10px" v-html="g_getActivityAction(activity)"></span>
                        <span class="status"
                            v-if="getSystemLanguage == 'english'">{{ getTime(activity.createdAt) }}</span>
                    </div>
                </div>
                <div class="dot_line" style="height:00px"></div>
            </va-column>
        </va-row>

        <va-row>
            <va-column>
                <va-button :loading="loadingActivities" v-if="allActivitiesCount > activities.length"
                    style="margin-left: 20px;min-height: 20px;" @click.native="fetchActivities(++page)">{{ _('More') }}
                </va-button>
                <va-button v-if="allActivitiesCount ==0" style="margin-left: 20px;min-height: 20px;">
                    {{_('No Activities')}}
                </va-button>

            </va-column>
        </va-row>

    </div>
</template>

<script>
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from 'vuex'
    import moment from 'moment'


    export default {

        props: ['form'],
        data() {
            return {
                page: 1,
                commentText: '',
                activities: [],
                allActivitiesCount: null,
                section: '',
                loadingActivities: false,
                currentDepartment: null,
                category: null,
            }
        },

        computed: {
            ...mapGetters(['user', 'loading', 'getSystemLanguage', 'getCurrentDepartment', 'getCurrentCategory', 'getUserDepartmentsFromState']),
            getCategory() {
                return this.category || this.getCurrentCategory
            },
        },


        methods: {

            async navigate(activity) {
                var id
                if (activity.get('class') == 'Filter') {
                    id = activity.get('url').split('=')[1]
                } else {
                    id = activity.get('url').split('/')[activity.get('url').split('/').length - 1]
                }

                // !this.$route.params.id: means we are not viewing an object right now
                if (activity && !this.$route.params.id && activity.get('action') != 'delete' && activity.get('action') != 'deleteFilters' && activity.get('action') != 'deleteSubmissions') {

                    if (activity.get('class') == 'Category') {
                        // for category
                        let q = new Parse.Query('Cateogry')
                        q.equalTo('slug', id)
                        let result = await q.first()

                        if (!result) {
                            this.$router.push(activity.get('url'))
                        } else {
                            this.$notify({
                                group: 'foo',
                                text: this._('There is an error navigating to this link, the object might not exist or you do not have the permission to view'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        }

                    } else {
                        if (id != 'list') {
                            this.g_fetchObject(id, activity.get('class')).then(res => {
                                if (activity.get('class') == 'Form')
                                    if (res.get('is_enabled'))
                                        this.$router.push(activity.get('url'))
                                    else {
                                        this.$notify({
                                            group: 'foo',
                                            text: this._('There is an error navigating to this link, the object might not exist'),
                                            duration: 4000,
                                            position: 'top left',
                                            type: 'error'
                                        });
                                    }
                                else if (activity.get('class') == 'Article' || activity.get('class') == 'File' || activity.get('class') == 'Map') {
                                    if (res.get('status') == 'approved')
                                        this.$router.push(activity.get('url'))

                                    else if (res.get('status') == 'rejected' || res.get('status') == 'pending') {
                                        if (this.user.get('roles').includes('admin') || this.user.get('roles').includes('manager')) {
                                            this.$router.push(activity.get('url'))
                                        } else {
                                            if (res.get('createdBy').id == this.user.id) {
                                                this.$router.push(activity.get('url'))
                                                return;
                                            }
                                            for (const key in res.get('approvers')) {

                                                if (res.get('approvers')[key].id == this.user.id) {
                                                    this.$router.push(activity.get('url'))
                                                    return;
                                                }
                                            }
                                            this.$notify({
                                                group: 'foo',
                                                text: this._('You do not have the permission to view this ' + activity.get('class').toLowerCase()),
                                                duration: 4000,
                                                position: 'top left',
                                                type: 'error'
                                            });
                                        }
                                    }
                                }
                                else this.$router.push(activity.get('url'))

                            }).catch(e => {
                                this.$notify({
                                    group: 'foo',
                                    text: this._('There is an error navigating to this link, the object might not exist'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                        } else {
                            let className = 'Data_' + activity.get('url').split('/')[activity.get('url').split('/').length - 2]
                            let q = new Parse.Query('Form')
                            q.equalTo('is_enabled', true)
                            q.equalTo('class_name', className)
                            let result = await q.first()
                            if (result)
                                this.$router.push(activity.get('url'))
                            else {
                                this.$notify({
                                    group: 'foo',
                                    text: this._('There is an error navigating to this link, the object might not exist'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            }
                        }
                    }
                }
            },

            getPreviousLabel(activity) {
                if (activity == null) return "n/a";
                if (this.getSystemLanguage == "dari")
                    if (activity.get("previous_label_dari") == "") return 'n/a'
                    else
                        return activity.get("previous_label_dari");
                else if (
                    this.getSystemLanguage == "pashto")
                    if (activity.get("previous_label_pashto") == "") return 'n/a'
                    else
                        return activity.get("previous_label_pashto");
                else return activity.get("previous_label_english");
            },

            getTime(time) {
                return moment(time).fromNow()
            },

            addComment() {
                if (this.commentText != '') {
                    var reference_id = '';
                    if (this.section == 'survey' || this.section == 'article' || this.section == 'file' || this.section == 'map') {
                        if (this.section == 'survey' && this.$route.name == 'submission') {

                            if (this.form != null) {
                                reference_id = this.form.id
                            }
                        } else {
                            reference_id = this.$route.path.id
                        }
                    } else {
                        reference_id = this.$route.path.id
                    }
                    let newActivity = Parse.Object.extend('Activity').createWithoutData()
                    newActivity.save({
                        comment: this.commentText.trim(),
                        url: this.$route.path,
                        type: this.section,
                        action: 'comment',
                        class: this.sectionCapitalized,
                        category: this.category,
                        department: this.currentDepartment,
                        is_comment: true,
                        createdBy: this.user,
                        reference_id: reference_id
                    }).then(async inserted => {
                        this.commentText = ''
                        await this.fetchActivitiesCout()
                    }).catch(e => {

                    })
                }
            },



            async fetchActivities(pageNumber) {
                if (this.user != null) {
                    this.loadingActivities = true
                    let q = new Parse.Query('Activity')
                    var conditions = []
                    conditions.push(new Parse.Query('Activity').equalTo('type', this.section))
                    if (this.$route.params.id) conditions.push(new Parse.Query('Activity').equalTo('url', this.$route.path))
                    if (this.user.get('type') == 'admin') {
                        // admin
                    } else if (this.user.get('type') == 'manager' || this.user.get('type') == 'user') {
                        // manager and role-based users
                        var tempDepartments = [];
                        if (this.getUserDepartmentsFromState && this.getUserDepartmentsFromState.length != 0) {
                            for (const key in this.getUserDepartmentsFromState) {
                                if (this.getUserDepartmentsFromState[key]) {
                                    tempDepartments.push(makePointer('Department', this.getUserDepartmentsFromState[key].id))
                                }
                            }
                        }

                        if (this.$route.name == 'survyesDashboard' || this.$route.name == 'sectionDashboard') {
                            // for dashboard
                            if (this.$route.name == 'survyesDashboard') {
                                if (this.user.get('roles').includes('survey-approver') || this.user.get('roles').includes('submission-approver') || this.user.get('roles').includes('submitter')) {
                                    var temp = [];
                                    temp.push(new Parse.Query("Activity").equalTo('to', this.user))
                                    temp.push(new Parse.Query("Activity").equalTo('createdBy', this.user))
                                    conditions.push(Parse.Query.or(...temp))
                                }
                            } else {
                                if (this.user.get('roles').includes(this.section + '-approver') || this.user.get('roles').includes(this.section + '-creator')) {
                                    var temp = [];
                                    temp.push(new Parse.Query("Activity").equalTo('to', this.user))
                                    temp.push(new Parse.Query("Activity").equalTo('createdBy', this.user))
                                    conditions.push(Parse.Query.or(...temp))
                                }
                            }
                            conditions.push(new Parse.Query('Activity').containedIn('department', tempDepartments))
                        } else if (this.$route.name == 'formBuilderWrapper' || this.$route.name == 'submission' || this.$route.name == 'filePreview' || this.$route.name == 'mapPreview' || this.$route.name == 'articlePreview') {
                            // for others
                            conditions.push(new Parse.Query('Activity').containedIn('department', tempDepartments))
                        } else if (this.$route.name == 'users' || this.$route.name == 'departments') {

                        }

                    } else {
                        // guest
                    }




                    var mainQuery = Parse.Query.and(...conditions);
                    mainQuery.skip((pageNumber - 1) * 10)
                    mainQuery.limit(10)
                    mainQuery.select('createdBy', 'reference_id', 'createdAt', 'to', 'category', 'label_english', 'label_pashto', 'label_dari', 'previous_label_english', 'previous_label_pashto', 'previous_label_dari', 'action', 'type', 'class', 'url', 'department', 'seen', 'comment')
                    mainQuery.descending('createdAt')
                    mainQuery.include('createdBy')
                    mainQuery.include('to')
                    mainQuery.include('category')
                    mainQuery.include('department')
                    let results = await mainQuery.find();

                    let subscription = await q.subscribe();
                    subscription.on('create', async (activity) => {
                        if (activity.get('url') == this.$route.path) {
                            this.activities.unshift(activity)
                            await this.fetchActivitiesCout()
                        }
                    });

                    this.activities.push(...results)
                    this.loadingActivities = false
                }







                //     if (this.$route.params.id) conditions.push(new Parse.Query('Activity').equalTo('url', this.$route.path))
                //     if (this.section == 'survey') if (!this.$route.params.id && !this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes('survey-editor') && !this.user.get('roles').includes('survey-approver')) {
                //         var temp = [];
                //         temp.push(new Parse.Query("Activity").equalTo('to', this.user))
                //         temp.push(new Parse.Query("Activity").equalTo('createdBy', this.user))
                //         conditions.push(Parse.Query.or(...temp))
                //     }


            },

            async fetchActivitiesCout() {

                if (this.user != null) {
                    this.loadingActivities = true
                    let q = new Parse.Query('Activity')
                    var conditions = []
                    conditions.push(new Parse.Query('Activity').equalTo('type', this.section))
                    if (this.$route.params.id) conditions.push(new Parse.Query('Activity').equalTo('url', this.$route.path))
                    if (this.user.get('type') == 'admin') {
                        // admin
                    } else if (this.user.get('type') == 'manager' || this.user.get('type') == 'user') {
                        // manager and role-based users
                        var tempDepartments = [];
                        if (this.getUserDepartmentsFromState && this.getUserDepartmentsFromState.length != 0) {
                            for (const key in this.getUserDepartmentsFromState) {
                                if (this.getUserDepartmentsFromState[key]) {
                                    tempDepartments.push(makePointer('Department', this.getUserDepartmentsFromState[key].id))
                                }
                            }
                        }

                        if (this.$route.name == 'survyesDashboard' || this.$route.name == 'sectionDashboard') {
                            // for dashboard
                            if (this.$route.name == 'survyesDashboard') {
                                if (this.user.get('roles').includes('survey-approver') || this.user.get('roles').includes('submission-approver') || this.user.get('roles').includes('submitter')) {
                                    var temp = [];
                                    temp.push(new Parse.Query("Activity").equalTo('to', this.user))
                                    temp.push(new Parse.Query("Activity").equalTo('createdBy', this.user))
                                    conditions.push(Parse.Query.or(...temp))
                                }
                            } else {
                                if (this.user.get('roles').includes(this.section + '-approver') || this.user.get('roles').includes(this.section + '-creator')) {
                                    var temp = [];
                                    temp.push(new Parse.Query("Activity").equalTo('to', this.user))
                                    temp.push(new Parse.Query("Activity").equalTo('createdBy', this.user))
                                    conditions.push(Parse.Query.or(...temp))
                                }
                            }
                            conditions.push(new Parse.Query('Activity').containedIn('department', tempDepartments))
                        } else if (this.$route.name == 'formBuilderWrapper' || this.$route.name == 'submission' || this.$route.name == 'filePreview' || this.$route.name == 'mapPreview' || this.$route.name == 'articlePreview') {
                            // for others
                            conditions.push(new Parse.Query('Activity').containedIn('department', tempDepartments))
                        } else if (this.$route.name == 'users' || this.$route.name == 'departments') {

                        }

                    } else {
                        // guest
                    }

                    var mainQuery = Parse.Query.and(...conditions);
                    this.allActivitiesCount = await mainQuery.count();
                }
                // var conditions = []

                // if (this.$route.params.id) conditions.push(new Parse.Query('Activity').equalTo('url', this.$route.path))
                // if (this.section == 'survey') if (!this.$route.params.id && !this.user.get('roles').includes('admin') && !this.user.get('roles').includes('manager') && !this.user.get('roles').includes('survey-editor') && !this.user.get('roles').includes('survey-approver')) {
                //     var temp = [];
                //     temp.push(new Parse.Query("Activity").equalTo('to', this.user))
                //     temp.push(new Parse.Query("Activity").equalTo('createdBy', this.user))
                //     conditions.push(Parse.Query.or(...temp))
                // }
                // conditions.push(new Parse.Query('Activity').equalTo('type', this.section))

                // var mainQuery = Parse.Query.and(...conditions);
                // this.allActivitiesCount = await mainQuery.count()
            }

        },

        async mounted() {
            if (this.$route.name == 'formBuilderWrapper' || this.$route.name == 'submission' || this.$route.name == 'filePreview' || this.$route.name == 'mapPreview' || this.$route.name == 'articlePreview') {
                this.category = this.getCurrentCategory
                this.currentDepartment = this.getCurrentDepartment
            }
            if (this.$route.matched[0].name == 'department')
                this.section = this.$route.matched[0].name
            else
                this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)

            if (this.$route.params.form_slug) {
                this.sectionCapitalized = 'Data_' + this.$route.params.form_slug
                // if (this.$route.name == 'submission') {
                //     let q = new Parse.Query('Form')
                //     q.equalTo('class_name', 'Data_' + this.sectionCapitalized)
                //     let viewedForm = await q.first()
                // }
            } else this.sectionCapitalized = this.section.charAt(0).toUpperCase() + this.section.slice(1)
            await this.fetchActivitiesCout()
            await this.fetchActivities(1)
        }

    }
</script>

<style>
    .dot_line {
        border-left: 1px solid #d1d8dd;
        margin-left: 46px;
        position: absolute;
        height: 100%;
    }

    .short_line {
        height: 20px !important;
    }

    .activity_wrapper_click {
        width: 100%;
        cursor: pointer !important;
        display: flex;
        align-items: center;
        position: relative;

    }

    .activity_wrapper_no_click {
        pointer-events: none;
    }

    .activity_img::before {
        content: '';
        border-left: 1px solid;
        height: 100%;
        position: absolute;
        left: 46px;
    }
</style>